module.exports = __webpack_public_path__ + "img/85c3197.jpg";